import Vue from 'vue'
import axios from 'axios'
import { initServer } from '../../config'

Vue.prototype.$http = axios

const server = initServer()

axios.interceptors.request.use(function (config) {
  config.baseURL = server
  config.headers.common.author = 'soonfy'
  const token = sessionStorage.token
  // console.log(token)
  if (token) {
    config.headers.common.authorization = `Bearer ${token}`
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response.data
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})
